import React, { FC } from 'react';
import { AccountType } from 'types/types';
import ProIcon from 'components/icons/account-types/pro.svg?react';
import DistributorIcon from 'components/icons/account-types/distributor.svg?react';
import DeveloperIcon from 'components/icons/account-types/developer.svg?react';
import PersonalIcon from 'components/icons/account-types/personal.svg?react';

const icons = {
  pro: ProIcon,
  distributor: DistributorIcon,
  developer: DeveloperIcon,
  personal: PersonalIcon,
};

export interface AccountTypeIconProps {
  accountType: AccountType;
  className?: string;
}

const AccountTypeIcon: FC<AccountTypeIconProps> = ({
  accountType,
  className,
}): JSX.Element => {
  const Icon = icons[accountType];
  return <Icon className={className} />;
};

export default AccountTypeIcon;
